import style from "./style.module.css"
import ScreenLeftImage from "../../../../assets/screen-left-count.svg"
import { useSelector } from "react-redux";
const ScreenLeftCount = ({closePopup}) => {
    
    const TestReducer = useSelector(store => store.TestReducer);
    return(
        <div className={style.mainDiv}>
            <img className={style.imageStyle} src={ScreenLeftImage} alt="..." />
            <h3 className={style.heading}>You Left Exam!</h3>
            <p className={style.subHeading}>System found that you minimized tab or changed browser tab. {5 - TestReducer.screen_left_count} chances are left for you.</p>
            <button onClick={()=>closePopup()} className={style.understoodBtn}>Understood</button>
        </div>
    )
}

export default ScreenLeftCount;